import React from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import "./LoungeVideoLayout.css";

/**
 * Props (adjust as needed):
 * - localVideoRef: React ref for my own video element
 * - remoteParticipants: array of { id, name, videoRef, isMuted, isSelf?: boolean }
 * - isFullscreen: boolean for fullscreen mode
 * - onToggleFullscreen: callback to toggle fullscreen
 */
export function LoungeVideoLayout({ 
  localVideoRef, 
  remoteParticipants = [],
  isFullscreen = false,
  onToggleFullscreen = null,
}) {
  const remoteOnly = remoteParticipants.filter(p => !p.isSelf);
  const hasRemote = remoteOnly.length > 0;

  return (
    <div className={`lounge-video-root ${isFullscreen ? "lounge-video-root--fullscreen" : ""}`}>
      {/* Fullscreen toggle button */}
      {onToggleFullscreen && (
        <button
          type="button"
          onClick={onToggleFullscreen}
          title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
          className="lounge-video-fullscreen-btn"
          data-testid="lounge-fullscreen-btn"
        >
          {isFullscreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
        </button>
      )}

      {/* Main remote area (or local full-screen if no remote yet) */}
      <div
        className={
          hasRemote
            ? "lounge-video-remote-grid"
            : "lounge-video-remote-grid lounge-video-remote-grid--solo"
        }
      >
        {hasRemote ? (
          remoteOnly.map((p) => (
            <div key={p.id} className="lounge-video-tile">
              <video
                ref={p.videoRef}
                autoPlay
                playsInline
                className="lounge-video-element"
              />
              <div className="lounge-video-overlay">
                <span className="lounge-video-name">
                  {p.name || "Guest"}
                </span>
                {p.isMuted && (
                  <span className="lounge-video-status">Mic off</span>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="lounge-video-tile lounge-video-tile--placeholder">
            <video
              ref={localVideoRef}
              autoPlay
              muted
              playsInline
              className="lounge-video-element"
            />
            <div className="lounge-video-overlay">
              <span className="lounge-video-name">Waiting for a match…</span>
            </div>
          </div>
        )}
      </div>

      {/* Local PiP bubble (always shows my own preview when camera is on) */}
      <div className="lounge-video-local-pip">
        <video
          ref={localVideoRef}
          autoPlay
          muted
          playsInline
          className="lounge-video-element lounge-video-element--pip"
        />
        <div className="lounge-video-overlay lounge-video-overlay--pip">
          <span className="lounge-video-name">You</span>
        </div>
      </div>
    </div>
  );
}
